// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation_navigation__37q2-"};